module.exports = __webpack_public_path__ + "img/P150T_weapon_110.ed360221.png";